<h1 mat-dialog-title>
    {{'Do you want to delete' | translate}} <span class="bold">{{data.type}} </span>
    <span class="bold">{{data.project}}</span> {{'with ID' | translate}} <span class="bold">{{data.batchID}}</span>?
</h1>
<div mat-dialog-actions>
  <button mat-raised-button (click)="onNoClick()">{{'No' | translate}}</button>
  <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>{{'Yes' | translate}}</button>
</div>